export default __webpack_public_path__ + "static/media/stud-labs-creative-process.c5207b17.jpg";